import { render, staticRenderFns } from "./PunchClock.vue?vue&type=template&id=6c5bd4ec&scoped=true"
import script from "./PunchClock.vue?vue&type=script&lang=js"
export * from "./PunchClock.vue?vue&type=script&lang=js"
import style0 from "./PunchClock.vue?vue&type=style&index=0&id=6c5bd4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bd4ec",
  null
  
)

export default component.exports